import { render } from "./insuranceDocumentAbout.vue?vue&type=template&id=10980c9f&scoped=true"
import script from "./insuranceDocumentAbout.vue?vue&type=script&lang=js"
export * from "./insuranceDocumentAbout.vue?vue&type=script&lang=js"

import "./insuranceDocumentAbout.vue?vue&type=style&index=0&id=10980c9f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10980c9f"]])

export default __exports__